import { HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse, HttpStatusCode } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, Subscription, tap, throwError } from 'rxjs';
import { AuthInfo } from '../interfaces/auth-info';
import { LoginData } from '../interfaces/login-data';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  user?: AuthInfo;

  emitter = new EventEmitter<AuthInfo>();

  constructor(private http: HttpClient, private router: Router) {
    console.log('user', localStorage.getItem('user'));
    this.user = JSON.parse(localStorage.getItem('user') || 'null');
    this.emitter.emit(this.user);
  }


  private deleteData() {
    this.user = undefined;
    localStorage.removeItem('user');
    localStorage.removeItem('creds');
  }


  login(data?: LoginData) {
    if (data) {
      const creds = window.btoa(`${data.username}:${data.password}`);
      localStorage.setItem('creds', creds);
    }
    return this.http.get<AuthInfo>('/api/v1/login').pipe(
      tap(d => {
        this.user = d;
        console.log('login result:', d.username, d);
        this.emitter.emit(d);
        localStorage.setItem('user', JSON.stringify(this.user));
      }), catchError((e: HttpErrorResponse) => {
        this.deleteData();
        return throwError(() => e);
      }));
  }

  logout() {
    this.deleteData();
    this.emitter.emit(undefined);
  }

  loggedIn(): boolean {
    return !!this.user;
  }

  currentUser(): AuthInfo | undefined {
    return this.user;
  }

  subscribe(next: (info: AuthInfo) => void): Subscription {
    return this.emitter.subscribe(next);
  }

}
